import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {classes} from './description.st.css'

export const Description = props => {
  return <Text typography={TextTypography.runningText} {...props} className={classes.root} />
}
